import { c as _c } from "react/compiler-runtime";
import { BBookableTypeEnum } from '@/types/backend';
import { FTunnelPageBookingTypeEnum } from '@/types/tunnel';
import { Error } from '@winelidays/wld-tsx-2/elements';
import useTunnelBookingType from '../context/hooks/useTunnelBookingType';
import useTunnelExperience from '../context/hooks/useTunnelExperience';
import ActivityBooking from './ActivityBooking';
import MealBooking from './MealBooking';
import VoucherBooking from './VoucherBooking';
const BookingPage = () => {
    const $ = _c(8);
    const { experience } = useTunnelExperience();
    const bookingType = useTunnelBookingType();
    if (!experience) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = <>
        <Error>Error: Failed to retrieve experience</Error></>;
            $[0] = t0;
        }
        else {
            t0 = $[0];
        }
        return t0;
    }
    switch (bookingType) {
        case FTunnelPageBookingTypeEnum.voucher: {
            let t0;
            if ($[1] !== experience) {
                t0 = <VoucherBooking experience={experience}/>;
                $[1] = experience;
                $[2] = t0;
            }
            else {
                t0 = $[2];
            }
            return t0;
        }
        case FTunnelPageBookingTypeEnum.standard: { }
        default: {
            switch (experience.type) {
                case BBookableTypeEnum.Activity: {
                    const t0 = experience;
                    let t1;
                    if ($[3] !== t0) {
                        t1 = <ActivityBooking experience={t0}/>;
                        $[3] = t0;
                        $[4] = t1;
                    }
                    else {
                        t1 = $[4];
                    }
                    return t1;
                }
                case BBookableTypeEnum.Meal: {
                    const t0 = experience;
                    let t1;
                    if ($[5] !== t0) {
                        t1 = <MealBooking experience={t0}/>;
                        $[5] = t0;
                        $[6] = t1;
                    }
                    else {
                        t1 = $[6];
                    }
                    return t1;
                }
                default: {
                    let t0;
                    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
                        t0 = <>
                  <Error>Error: Unknown experience type</Error></>;
                        $[7] = t0;
                    }
                    else {
                        t0 = $[7];
                    }
                    return t0;
                }
            }
        }
    }
};
export default BookingPage;
